import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const GoldGuard = ({ children }) => {
  const navigate = useNavigate();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const userSubscription = userInfo?.subscription || 'Basic';
  const isSuperAdmin = userInfo?.role_name === 'SuperAdmin';

  useEffect(() => {
    if (!isSuperAdmin && String(userSubscription).toLowerCase() !== 'gold') {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [userSubscription, isSuperAdmin, navigate]);

  return isSuperAdmin || String(userSubscription).toLowerCase() === 'gold' ? children : null;
};

GoldGuard.propTypes = {
  children: PropTypes.node
};

export default GoldGuard;
